import clsx from 'clsx';
import { useCallback } from 'react';

import { AnnotationsCanvasMarker } from './AnnotationsCanvasMarker';
import type { Annotation, AnnotationDragDescriptor } from './AnnotationUtils';
import MarkerDropTarget from './MarkerDropTarget';
import styles from './ModuleAnnotationsStyles.css';

export type AnnotationsCanvasProps = {
  items: Annotation[];
  editing: boolean;
  onChange: (move: AnnotationDragDescriptor) => void;
  onMouseOver: (id: string) => void;
  onMouseOut: (id: string) => void;
  onClick: (id: string) => void;
  focusItemId: string;
};

export const AnnotationsCanvas = ({
  items,
  editing,
  onChange,
  onMouseOut,
  onMouseOver,
  onClick,
  focusItemId,
}: AnnotationsCanvasProps) => {
  const handleOnMouseOver = useCallback((id: string) => () => onMouseOver(id), [onMouseOver]);
  const handleOnMouseOut = useCallback((id: string) => () => onMouseOut(id), [onMouseOut]);
  const handleOnClick = useCallback((id: string) => () => onClick(id), [onClick]);

  return (
    <div className={clsx(styles.canvas, 'c-annotations__canvas')}>
      <MarkerDropTarget onMove={onChange}>
        {items.map((item, idx) => (
          <AnnotationsCanvasMarker
            position={item.position}
            editing={editing}
            key={item.id}
            index={idx}
            onMouseOver={handleOnMouseOver(item.id)}
            onMouseOut={handleOnMouseOut(item.id)}
            onClick={handleOnClick(item.id)}
            focus={focusItemId === item.id}
            blur={!!focusItemId && focusItemId !== item.id}
          />
        ))}
      </MarkerDropTarget>
    </div>
  );
};
